/**
 * Which topics this browser has opened, so an icon not yet opened carries a
 * small dot for a new user and stops once read. A per-viewer convenience:
 * storage may be unavailable (a private window), and then every icon simply
 * shows without its dot.
 */
const KEY = 'autonome-web:help-seen'

export function readSeenTopics(): ReadonlySet<string> {
  try {
    const raw = window.localStorage.getItem(KEY)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return new Set(Array.isArray(parsed) ? parsed.filter((entry): entry is string => typeof entry === 'string') : [])
  } catch {
    return new Set()
  }
}

export function markTopicSeen(id: string): void {
  try {
    const seen = readSeenTopics()
    if (!seen.has(id)) {
      window.localStorage.setItem(KEY, JSON.stringify([...seen, id]))
    }
  } catch {
    // Nothing to do: the dot stays, which costs the reader nothing.
  }
}
